import { directBillClients, notAuthedMessage } from "../service/constants"
import { monthNames } from "../service/constants"

export const isReport = appointmentType => {
    const type = appointmentType.toLowerCase()

    if (type.includes('initial report')) {
        return "Initial Repost"
    }

    if (type.includes('progress report')) {
        return "Progress report"
    }

    if (type.includes('clinical records')) {
        return "Clinical Records"
    }
}

export const isDirectBillClient = paymentSource => {
    let isDirectBill = false

    directBillClients.forEach(source => {
        if (paymentSource.includes(source)) {
            isDirectBill = true
        }
    })

    return isDirectBill
}

export const isPartPaid = (appointment) => appointment.paid === "yes" && appointment.amountPaid < appointment.price

export const generateDate = () => {
    const date = new Date()
    const mounth =  monthNames[date.getMonth()]
    const year = date.getFullYear()
    
    return `${mounth} ${year}`
}

export const showTable = (clients) => !!clients.length

export const formatDate = (date) => date.toISOString().slice(0, 10)

export const showClienAppointment = (appointment) => !appointment.canceled && !appointment.type.toLowerCase().includes('clinical record')

export const isAuthError = (errors) => errors.find(err => err.message === notAuthedMessage)

export const getDateDifference = (date) => {
    const currentDate = new Date();
    const expDate = new Date(date)

    return Math.ceil((expDate.getTime() - currentDate.getTime()) / (1000 * 3600 * 24));
}

export const generateAppDate = (date) => {
    const appDate = new Date(date)
    const mounth =  monthNames[appDate.getMonth()]
    const year = appDate.getFullYear()
    const day = appDate.getDate()

    return `${mounth}  ${day}, ${year}`
}

export const getEmailText = (name, date, text) => {
    const emailHead = ` Hi ${name},<br><br>
    Your ${date} invoice is now available. Please find the invoice in the attachment. The pay date is always on the last business day of the month, except special occasions.<br><br>`
    
    return `${emailHead} ${text}`
}

export const dateCompare = (maxDate, minDate) => {
    const maxTime = new Date(maxDate).getTime()
    const minTime = new Date(minDate).getTime()

    return maxTime > minTime
}

export const isEmpty = (obj) => {
    for (let key in obj) {
        return false;
    }
    
    return true;
}

export const sortClients = (clients) => clients.sort((a, b) => a.priority - b.priority)

export const getBadFitDate = (item) => {
    const appDate = new Date(item)
    const mounth =  monthNames[appDate.getMonth()]
    const year = appDate.getFullYear()

    return `${mounth} ${year}`
}